module.exports = __webpack_public_path__ + "static/10-d9fbe5cdcd4d485d5b1f0359acbfbd1a.png";